const workflowType = Object.freeze({
  DRAFT: 0,
  LIVE: 1,
  HISTORICAL: 2
})

export { workflowType }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/WorkflowTypeEnum.js